import { atom } from 'recoil';

const originState = atom({
  key: 'originState',
  default: null,
});

export { originState };
